import { render, staticRenderFns } from "./xheader.vue?vue&type=template&id=8c8fdf40&scoped=true&"
import script from "./xheader.vue?vue&type=script&lang=js&"
export * from "./xheader.vue?vue&type=script&lang=js&"
import style0 from "./xheader.vue?vue&type=style&index=0&id=8c8fdf40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8fdf40",
  null
  
)

export default component.exports